// module imports
import { Box } from '@mui/material';

// local imports
import ReusableAccordion from '../ReusableAccordion/ReusableAccordion';
import { BASEMAPS, BASEMAP_OPTION } from '../../../constants/BasemapOptions';
import BasemapOption from './BasemapOption';

interface BasemapAccordionProps {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, newExpanded: boolean) => void;
}

/**
 * BasemapAccordion
 *
 * Collapsible accordion that displays basemap options in the side panel.
 * @param {expanded} - Boolean indicating if the accordion is expanded or not.
 * @param {onChange} - Handler that updates the accordion expanded state.
 * @returns {React.ReactElement} - The BasemapAccordion component.
 */
export default function BasemapAccordion({
  expanded,
  onChange,
}: BasemapAccordionProps) {
  return (
    <ReusableAccordion title="Basemap" ariaLabel="Base map" expanded={expanded} onChange={onChange}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '1rem',
          justifyItems: 'center',
          py: 1,
        }}
      >
        {BASEMAPS.map((basemap: BASEMAP_OPTION) => (
          <BasemapOption
            key={basemap.identifier}
            identifier={basemap.identifier}
          />
        ))}
      </Box>
    </ReusableAccordion>
  );
}
